import { type ILastMessage } from '@repo/sdk'
import { Button } from '@repo/ui'
import { Dot, MessageSquare } from 'lucide-react'

interface IProps {
  currentUserId?: number
  handleChatClick?: () => void
  lastMessage?: ILastMessage
}

export const ChatIcon = ({ handleChatClick, lastMessage }: IProps) => {
  const isLastMessageMine = !lastMessage?.read_at && lastMessage?.chat_id

  return (
    <Button
      className={'relative w-[45px] items-center p-0'}
      onClick={() => {
        handleChatClick?.()
      }}
      variant="ghost"
    >
      {isLastMessageMine && (
        <Dot className={'absolute -right-2 -top-2.5 !size-11'} color={'#22C55E'} size={23} />
      )}
      <MessageSquare className={'!size-[24px]'} color={'#637381'} size={24} />
    </Button>
  )
}
